module.exports = __webpack_public_path__ + "static/img/image04.2eefd42.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sm/landingPage/image04.png
// module id = BUBB
// module chunks = 0